export const SelectionColours = {
  BLACK: "#000000",
  WHITE: "#FFFFFF",
  AQUA: "#A4C1E7",
  BROWN: "#6A3B28",
  KHAKI: "#4A5028",
  ORANGE: "#FC6410",
  LAKE: "#00876D",
  GREEN: "#596130",
  RED: "#B30000",
  BLUE: "#09369D",
  SAND: "#EEC8A2",
  DARK_ORANGE: "#CA4800",
  YELLOW: "#FFAD00",
  GREY: "#6E6E6E",
  DARK_CYAN: "#00A887",
  LIGHT_BLACK: "#111112",
  DARK_GREEN: "#050505",
  DARK_BLUE: "#0A1833",
  EMERALD: "#0F5B13",
  PINK: "#EF3D9D",
  CYAN: "#0090D3",
  SUNSHINE_YELLOW: "#FFDE02",
  LIGHT_BLUE: "#00A9E0",
  FOREST_GREEN: "#126C17",
  BABY_PINK: "#FCC8E4",
  STEEL_BLUE: "#ADADAD",
  GOLD: "#E1C38C",
  LEAF_GREEN: "#10AB1F",
  NAVY: "#2F3038",
  STEEL: "#E5E5E5",
};
